import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import Role from "@/utils/role";
Vue.use(Router);

import localStorage from "@/services/localStorage.service";
import studentRoutes from "./studentRoutes";
import teacherRoutes from "./teacherRoutes";

// import Credentials from '@/services/Credentials.service.js'
import New from "@/components/Curso/New";
// import ShowModule from '@/components/Module/ShowModule'
import ShowCurso from "@/components/Curso/ShowCurso";
import ShowLeccion from "@/components/Leccion/ShowLeccion";
import EditCource from "@/components/Curso/EditCurso";
import NewUnidad from "@/components/Unidad/NewUnidad";
import CurseInscrito from "@/components/Curso/ShowCursoInscrito";
import CuerseCreados from "@/components/Curso/ShowCursosCreados";
import NuevaLicencia from "@/components/Licencia/NewLicence";
import NuevoUsuario from "@/components/Usuario/NewUsuario";
import EditarUsuario from "@/components/Usuario/EditUsuario";
import UnidadesPorCurso from "@/components/Unidad/UnidadPerCurso";
import ContentUnity from "@/components/Unidad/ContentUnity";
import ShowPrueba from "@/components/Prueba/ShowPrueba";
import MaintainerEvaluation from "@/components/Prueba/MaintainerEvaluation";
import ShowInstituciones from "@/components/Institucion/ShowInstituciones";
import ShowFacultades from "@/components/Facultad/ShowFacultades";
import ShowCarreras from "@/components/Carrera/ShowCarreras";
import ShowCategory from "@/components/Categoria/ShowCategory";
import ShowGallery from "@/components/Galeria/ShowGalerias";
import EditEvaluacion from "@/components/Curso/EditEvaluacion";
import ShowCalificacion from "@/components/Prueba/ShowCalificacion";
import PreTest from "@/components/Prueba/PreTest";
import ListCourse from "@/components/Calificacion/ListCourse";
import ShowQualification from "@/components/Calificacion/ShowQualification";
import MantenedorAdministrador from "@/components/Administrador/Maintainer";
import LicencesUser from "@/components/Licencia/LicencesUser";
import TypeCompetences from "@/components/Administrador/tipoCompetencia";
import ShowCourcesOption from "@/components/Calificacion/ShowCourcesOption";
import ShowMembersInCources from "@/components/Calificacion/ShowMembersInCources";
import ShowListQualification from "@/components/Calificacion/ShowListQualification";
import QualificationsForUser from "@/components/Usuario/QualificationsForUser";
import GetAllUsuario from "@/components/Usuario/GetAllUsuarios";
import PerfilUser from "@/components/Usuario/Perfil";
import testing from "@/components/Testing/testing";

// const credentials = new Credentials()

const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  routes: [
    {
      name: 'LessonMeet',
      path: '/student/meet',
      component: () => import('@/views/Meet/Jitsi/Meet')
    },
    studentRoutes,
    {
      path: "/learning",
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "user-layout" */ "@/layouts/UserLayout"),
      children: [
        {
          name: "Forum",
          path: "forum",
          component: () => import("@/components/Forum/ForumPage")
        },
        {
          name: "NewPost",
          path: "forum/post",
          component: () => import("@/components/Forum/NewPost")
        },
        {
          name: "Post",
          path: "forum/post/:id",
          component: () => import("@/components/Forum/PostPage")
        },
        {
          name: "showCourse",
          path: "showCourse/:id",
          component: ShowCurso
        },
        {
          name: "newCource",
          path: "newCource",
          component: New
        },
        {
          name: "showLesson2",
          path: "showLesson2/:curso_id/:id",
          component: ShowLeccion
        },
        {
          name: "editCource",
          path: "editCource/:id",
          component: EditCource,
          beforeEnter: (to, from, next) => {
            if (localStorage.tipo === "2" || localStorage.tipo === "7") next();
            else next({ path: "/learning/courses" });
          }
        },
        {
          name: "editEvaluacion",
          path: "editEvaluacion/:id",
          component: EditEvaluacion,
          beforeEnter: (to, from, next) => {
            if (localStorage.tipo === "2" || localStorage.tipo === "7") next();
            else next({ path: "/learning/courses" });
          }
        },
        {
          name: "newUnity",
          path: "newUnity/:id",
          component: NewUnidad,
          beforeEnter: (to, from, next) => {
            if (localStorage.tipo === "2" || localStorage.tipo === "7") next();
            else next({ path: "/learning/courses" });
          }
        },
        {
          name: "curseInscrito",
          path: "curseInscrito",
          component: CurseInscrito
        },
        {
          name: "cursesCreated",
          path: "cursesCreated",
          component: CuerseCreados
        },
        {
          name: "newLicence",
          path: "newLicence",
          component: NuevaLicencia,
          beforeEnter: (to, from, next) => {
            if (localStorage.tipo === "7") next();
            else next({ path: "/learning/courses" });
          }
        },
        {
          name: "editUser",
          path: "editUser",
          component: EditarUsuario
        },
        {
          name: "Unidades",
          path: "Unidades/:id",
          component: UnidadesPorCurso
        },
        {
          name: "showInstitutions",
          path: "showInstitutions",
          component: ShowInstituciones,
          beforeEnter: (to, from, next) => {
            if (localStorage.tipo === "7") next();
            else next({ path: "/learning/courses" });
          }
        },
        {
          name: "maintainerEvaluation",
          path: "maintainerEvaluation",
          component: MaintainerEvaluation,
          beforeEnter: (to, from, next) => {
            if (localStorage.tipo === "7") next();
            else next({ path: "/learning/courses" });
          }
        },
        {
          name: "showFaculties",
          path: "showFaculties",
          component: ShowFacultades,
          beforeEnter: (to, from, next) => {
            if (localStorage.tipo === "7") next();
            else next({ path: "/learning/courses" });
          }
        },
        {
          name: "showCarreras",
          path: "showCarreras",
          component: ShowCarreras,
          beforeEnter: (to, from, next) => {
            if (localStorage.tipo === "7") next();
            else next({ path: "/learning/courses" });
          }
        },
        {
          name: "contentUnity",
          path: "contentUnity/:id",
          component: ContentUnity
        },
        {
          name: "showTest",
          path: "showTest/:id",
          component: ShowPrueba
        },
        {
          name: "showCalificacion",
          path: "showCalificacion/:id",
          component: ShowCalificacion
        },
        {
          name: "ShowCategory",
          path: "ShowCategory",
          component: ShowCategory,
          beforeEnter: (to, from, next) => {
            if (localStorage.tipo === "7") next();
            else next({ path: "/learning/courses" });
          }
        },
        {
          name: "ShowGalleries",
          path: "ShowGalleries",
          component: ShowGallery,
          beforeEnter: (to, from, next) => {
            if (localStorage.tipo === "7") next();
            else next({ path: "/learning/courses" });
          }
        },
        {
          name: "PreTest",
          path: "PreTest/:id",
          component: PreTest
        },
        {
          name: "ListCourses",
          path: "ListCourse",
          component: ListCourse
        },
        {
          name: "typeCompetences",
          path: "typeCompetences/:id",
          component: TypeCompetences
        },
        {
          name: "showQualifications",
          path: "showQualification/:id",
          component: ShowQualification
        },
        {
          name: "maintainer",
          path: "maintainer",
          component: MantenedorAdministrador,
          beforeEnter: (to, from, next) => {
            if (localStorage.tipo === "7") next();
            else next({ path: "/learning/courses" });
          }
        },
        {
          name: "licencesUser",
          path: "licencesUser/:id",
          component: LicencesUser
        },
        {
          name: "showCourcesOption",
          path: "showCourcesOption/:id",
          component: ShowCourcesOption
        },
        {
          name: "showMembersInCources",
          path: "showMembersInCources/:id",
          component: ShowMembersInCources
        },
        {
          name: "showListQualification",
          path: "showListQualification/:id",
          component: ShowListQualification
        },
        {
          name: "qualificationsForUser",
          path: "qualificationsForUser",
          component: QualificationsForUser
        },
        {
          name: "getAllUsuario",
          path: "getAllUsuario",
          component: GetAllUsuario,
          beforeEnter: (to, from, next) => {
            if (localStorage.tipo === "7") next();
            else next({ path: "/learning/courses" });
          }
        },
        {
          name: "testing",
          path: "testing",
          component: testing
        }
      ]
    },
    teacherRoutes,
    {
      name: "newUser",
      path: "/newUser",
      component: NuevoUsuario
    },
    {
      name: "Login",
      path: "/auth/login",
      component: () =>
        import(/* webpackChunkName: "login" */ "@/views/Auth/LoginPage")
    },
    {
      name: "Verified",
      path: "/auth/verified",
      component: () =>
        import(/* webpackChunkName: "verified" */ "@/views/Auth/VerifiedPage"),
      beforeEnter: (to, from, next) => {
        // if (localStorage.getItem("data") && localStorage.getItem("nextRoute")) {
        next();
        // } else {
        //   next('/auth/login');
        // }
      }
    },
    {
      name: "perfilUser",
      path: "/auth/perfiluser",
      component: PerfilUser,
      beforeEnter: (to, from, next) => {
        if (
          localStorage.tipo === "1" ||
          localStorage.tipo === "2" ||
          localStorage.tipo === "3" ||
          localStorage.tipo === "4" ||
          localStorage.tipo === "7"
        ) {
          next();
        } else next({ path: "/" });
      }
    },
    {
      name: "resetPassword",
      path: "/auth/reset-password/:id",
      component: () => import("@/views/Auth/ResetPassword")
    },
    {
      name: "ForgotPassword",
      path: "/auth/forgot-password",
      component: () => import("@/views/Auth/ForgotPassword")
    },
    {
      name: "404",
      path: "*",
      redirect: "learning/courses"
      // component: () => import(/* webpackChunkName: "404" */ '@/components/404')
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  // La ruta requiere autentificación
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Continuamos con la navegación si el usuario esta autentificado
    if (store.getters.isAuthenticated) next();
    // En caso contrario lo enviamos al Login
    else next({ name: "Login" });
  } else {
    // Evitamos que un usuario logeado ingrese a alguna vista con el path auth
    const visitorRoute = to.path.includes("auth") || to.path === "/newUser";
    if (store.getters.isAuthenticated && visitorRoute) {
      if (store.state.role === Role.STUDENT) {
        next({ path: "/student/courses" });
      } else if (store.state.role === Role.ADMIN) {
        next({ path: "/learning/admin/courses" });
      } else {
        next({ path: "/learning/courses" });
      }
    } else {
      next();
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js